import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VMenu, {
    attrs: {
      "title": _vm.$i18n_t('Common.userSettings'),
      "offset-x": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on
      }) {
        return [_c(VBtn, _vm._g({
          class: 'mr-2 v-btn-x v-btn--rounded bg-rounded-button-' + _vm.color,
          attrs: {
            "title": _vm.$i18n_t('Common.customizeInterface'),
            "icon": "",
            "rounded": ""
          }
        }, on), [_c(VIcon, {
          attrs: {
            "color": _vm.color
          }
        }, [_vm._v("fas fa-user")])], 1)];
      }
    }])
  }, [_c(VCard, {
    staticClass: "toolbar-menu-vcard"
  }, [_c(VList, [_vm.showTicketNotificationBell ? _c(VListItem, [_c(VListItemAvatar, {
    staticStyle: {
      "overflow": "unset"
    }
  }, [_c(VBadge, {
    attrs: {
      "overlap": "",
      "color": "danger"
    },
    scopedSlots: _vm._u([{
      key: "badge",
      fn: function () {
        return [_vm._v("\n                " + _vm._s(_vm.newTicketCount) + "\n              ")];
      },
      proxy: true
    }], null, false, 936091086)
  }, [_c(VIcon, {
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v("fas fa-bell")])], 1)], 1), _c('div', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": "",
      "to": "/fm-ticketing-mgmt"
    }
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.ticketsTableHead')))])], 1)], 1) : _vm._e(), _vm.canCreateTickets && (_vm.$vuetify.breakpoint.mdAndUp || !_vm.showTicketNotificationBell) ? _c(VListItem, [_c(VListItemAvatar, [_c(VIcon, {
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v("fas fa-file-plus")])], 1), _c('div', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": "",
      "to": "/fm-add-ticket"
    }
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.drawer.fmTicketsAdd')))])], 1)], 1) : _vm._e(), _c(VDivider), _c(VListItem, [_c(VListItemAvatar, [_c(VIcon, {
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v("fas fa-cog")])], 1), _c('div', [_c('core-filter', {
    attrs: {
      "userT": _vm.userT
    }
  })], 1)], 1), _c(VListItem, [_c(VListItemAvatar, [_c(VIcon, {
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v("fal fa-question-circle")])], 1), _c('div', [_c('core-help')], 1)], 1)], 1), _c(VDivider), _c(VList, [_c(VListItem, [_c(VListItemAvatar, [_c(VIcon, {
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v("fas fa-sign-out")])], 1), _c('div', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.logout.apply(null, arguments);
      }
    }
  }, [_vm._v(_vm._s(_vm.$i18n_t('Core.Toolbar.logoutBtn')))])], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };